(function() {
  'use strict';

  const config = {
    checkInterval: 500,
    maxAttempts: 20,
    nostoSelectors: [
      '[data-nosto-placement*="-nosto-"]',
      '[id*="page-nosto-"]',
      '[id*="-nosto-"][class*="nosto"]',
      '[id^="frontpage-nosto-"]',
      '[id^="categorypage-nosto-"]',
      '[id^="productpage-nosto-"]',
      '[id^="searchpage-nosto-"]',
      '.template-search [data-recommendation-id]',
      '.template-search .nosto_element',
      'body.template-search [id*="nosto"]'
    ]
  };

  let attempts = 0;
  let processedContainers = new Set();
  let keenSliderInstances = new Map();

  function upgradeImageResolution(img) {
    const src = img.getAttribute('src');
    if (src && src.includes('_200x200')) {
      const highResSrc = src.replace('_200x200', '_800x800');
      img.setAttribute('src', highResSrc);
      
      const srcset = img.getAttribute('srcset');
      if (srcset) {
        const highResSrcset = srcset.replace(/_200x200/g, '_800x800');
        img.setAttribute('srcset', highResSrcset);
      }
    }
  }

  function openQuickView(url) {
    if (typeof $s === 'undefined' || typeof $s.openModal !== 'function') {
      window.location.href = url.replace('view=quick-view', '');
      return;
    }

    if (typeof $s.showLoadingOverlay === 'function') {
      $s.showLoadingOverlay();
    }
    if (typeof $ !== 'undefined' && $.ajax) {
      $.ajax({
        url: url,
        type: 'GET',
        dataType: 'html',
        success: function(html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const section = doc.querySelector('.product-main-element');
          
          if (section) {
            const shopifySection = section.closest('.shopify-section');
            
            if (shopifySection) {
              $s.openModal(shopifySection, 'product-quick-view');
              if (typeof $s.globalEval === 'function') {
                $s.globalEval(shopifySection);
              }
            }
          }
        },
        complete: function() {
          if (typeof $s.hideLoadingOverlay === 'function') {
            $s.hideLoadingOverlay();
          }
        }
      });
    } else {
      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const section = doc.querySelector('.product-main-element');
          
          if (section) {
            const shopifySection = section.closest('.shopify-section');
            if (shopifySection) {
              $s.openModal(shopifySection, 'product-quick-view');
              if (typeof $s.globalEval === 'function') {
                $s.globalEval(shopifySection);
              }
            }
          }
        })
        .finally(() => {
          if (typeof $s.hideLoadingOverlay === 'function') {
            $s.hideLoadingOverlay();
          }
        });
    }
  }

  function initKeenSlider(container) {
    let productGrid = container.querySelector('.product-grid');
    if (!productGrid) return;

    if (keenSliderInstances.has(container) || productGrid.classList.contains('keen-slider')) {
      return;
    }

    if (typeof KeenSlider === 'undefined') {
      return;
    }

    const productCards = productGrid.querySelectorAll('.product-card');
    if (productCards.length === 0) return;

    if (productGrid.tagName === 'UL') {
      const newGrid = document.createElement('div');
      Array.from(productGrid.attributes).forEach(attr => {
        newGrid.setAttribute(attr.name, attr.value);
      });
      newGrid.setAttribute('role', 'list');
      
      while (productGrid.firstChild) {
        const child = productGrid.firstChild;
        if (child.tagName === 'LI') {
          const newChild = document.createElement('div');
          Array.from(child.attributes).forEach(attr => {
            newChild.setAttribute(attr.name, attr.value);
          });
          newChild.setAttribute('role', 'listitem');
          
          while (child.firstChild) {
            newChild.appendChild(child.firstChild);
          }
          newGrid.appendChild(newChild);
          productGrid.removeChild(child);
        } else {
          newGrid.appendChild(child);
        }
      }
      productGrid.parentNode.replaceChild(newGrid, productGrid);
      productGrid = newGrid;
    }

    productGrid.classList.add('keen-slider', 'RS-nosto-keen-slider');
    
    const cards = productGrid.querySelectorAll('.product-card');
    cards.forEach(card => {
      if (card.parentElement.classList.contains('keen-slider__slide')) {
        return;
      }
      const slideWrapper = document.createElement('div');
      slideWrapper.className = 'keen-slider__slide';
      card.parentNode.insertBefore(slideWrapper, card);
      slideWrapper.appendChild(card);
    });

    const carouselWrapper = document.createElement('div');
    carouselWrapper.className = 'RS-nosto-carousel-wrapper';
    
    const title = container.querySelector('h4');
    if (title) {
      container.insertBefore(carouselWrapper, title);
      carouselWrapper.appendChild(title);
    } else {
      productGrid.parentNode.insertBefore(carouselWrapper, productGrid);
    }
    
    carouselWrapper.appendChild(productGrid);

    const navContainer = document.createElement('div');
    navContainer.className = 'keen-nav-bar RS-carousel-nav';

    const prevBtn = document.createElement('button');
    prevBtn.className = 'keen-arrow keen-arrow-prev RS-carousel-arrow RS-carousel-prev prev';
    prevBtn.setAttribute('aria-label', 'Go to previous slide');
    prevBtn.innerHTML = '<svg class="icon icon-arrow-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="m5,12c0-.19.1-.41.24-.55L16.45.24c.14-.14.36-.24.55-.24s.41.1.55.24l1.2,1.2c.14.14.24.34.24.55,0,.19-.1.41-.24.55l-9.45,9.45,9.45,9.45c.14.14.24.36.24.55s-.1.41-.24.55l-1.2,1.2c-.14.14-.36.24-.55.24s-.41-.1-.55-.24L5.24,12.55c-.14-.14-.24-.36-.24-.55h0Z" stroke-width="0"/></svg>';
    
    const nextBtn = document.createElement('button');
    nextBtn.className = 'keen-arrow keen-arrow-next RS-carousel-arrow RS-carousel-next next';
    nextBtn.setAttribute('aria-label', 'Go to next slide');
    nextBtn.innerHTML = '<svg class="icon icon-arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="m19,12c0,.19-.1,.41-.24,.55l-11.21,11.21c-.14.14-.36.24-.55.24s-.41-.1-.55-.24l-1.2-1.2c-.14-.14-.24-.34-.24-.55,0-.19.1-.41.24-.55l9.45-9.45L5.24,2.55c-.14-.14-.24-.36-.24-.55s.1-.41.24-.55L6.45.24C6.59.09,6.81,0,7,0s.41.1.55.24l11.21,11.21c.14.14.24.36.24.55h0Z" stroke-width="0"/></svg>';

    navContainer.appendChild(prevBtn);
    navContainer.appendChild(nextBtn);
    carouselWrapper.appendChild(navContainer);

    const sliderConfig = {
      loop: true,
      mode: 'free-snap',
      rubberband: false,
      drag: true,
      slides: '.keen-slider__slide',
      controls: true,
      prevButton: prevBtn,
      nextButton: nextBtn,
      created: (slider) => {
        prevBtn.classList.remove('disabled');
        prevBtn.disabled = false;
        nextBtn.classList.remove('disabled');
        nextBtn.disabled = false;
        
        setTimeout(() => {
          updateNavigationState(slider, prevBtn, nextBtn, container);
        }, 200);
      },
      slideChanged: (slider) => {
        updateNavigationState(slider, prevBtn, nextBtn, container);
      },
      breakpoints: {
        '(max-width: 600px)': {
          slidesPerView: 1.52,
          spacing: 8
        },
        '(min-width: 601px) and (max-width: 1200px)': {
          slidesPerView: 2.53,
          spacing: 8
        },
        '(min-width: 1201px)': {
          slidesPerView: 3.56,
          spacing: 8
        }
      }
    };

    try {
      const slider = new KeenSlider(productGrid, sliderConfig);
      keenSliderInstances.set(container, slider);

      window.addEventListener('resize', () => {
        slider.update();
        updateNavigationState(slider, prevBtn, nextBtn, container);
      });

      setTimeout(() => {
        updateNavigationState(slider, prevBtn, nextBtn, container);
      }, 100);
    } catch (error) {
      productGrid.classList.remove('keen-slider', 'RS-nosto-keen-slider');
      const slides = productGrid.querySelectorAll('.keen-slider__slide');
      slides.forEach(slide => {
        while (slide.firstChild) {
          slide.parentNode.insertBefore(slide.firstChild, slide);
        }
        slide.remove();
      });
    }
  }

  function updateNavigationState(slider, prevBtn, nextBtn, container) {
    const details = slider.details();
    const totalSlides = details.size;
    const slidesPerView = getSlidesPerViewForSlider();
    
    const needsNavigation = totalSlides > Math.floor(slidesPerView);
    container.setAttribute('data-carousel-active', needsNavigation ? 'true' : 'false');
    
    prevBtn.classList.remove('disabled');
    prevBtn.disabled = false;
    nextBtn.classList.remove('disabled');
    nextBtn.disabled = false;
  }

  function getSlidesPerViewForSlider() {
    const width = window.innerWidth;
    if (width <= 600) {
      return 1.52;
    } else if (width <= 1200) {
      return 2.53;
    } else {
      return 3.56;
    }
  }

  function applyNostoStyles() {
    const nostoContainers = document.querySelectorAll(config.nostoSelectors.join(','));
    
    if (nostoContainers.length === 0) {
      return false;
    }

    let newContainersFound = false;

    nostoContainers.forEach(container => {
      if (processedContainers.has(container)) {
        return;
      }

      if (container.tagName === 'FEATURED-PRODUCTS' || container.closest('featured-products')) {
        return;
      }

      processedContainers.add(container);
      newContainersFound = true;

      container.classList.add('RS-nosto-styled');
      container.setAttribute('data-nosto-placement', '');

      const checkContent = () => {
        const productGrid = container.querySelector('.product-grid');
        if (productGrid && productGrid.querySelectorAll('.product-card').length > 0) {
          
          const products = container.querySelectorAll('[class*="product"], article, .item');
          
          products.forEach(product => {
            product.classList.add('RS-nosto-product');
            
            const productLink = product.querySelector('a.product-link');
            const productUrl = productLink ? productLink.getAttribute('href') : null;
            
            const images = product.querySelectorAll('img');
            images.forEach(img => {
              upgradeImageResolution(img);
              
              if (!img.parentElement.classList.contains('RS-nosto-img-wrapper')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'RS-nosto-img-wrapper';
                img.parentNode.insertBefore(wrapper, img);
                wrapper.appendChild(img);
              }
            });

            const imgContainer = product.querySelector('.product-img');
            if (imgContainer && productUrl && !imgContainer.querySelector('.RS-quick-view-btn')) {
              const quickViewBtn = document.createElement('button');
              quickViewBtn.className = 'RS-quick-view-btn';
              quickViewBtn.textContent = 'QUICK VIEW';
              quickViewBtn.setAttribute('type', 'button');
              quickViewBtn.setAttribute('tabindex', '0');
              
              const separator = productUrl.includes('?') ? '&' : '?';
              const quickViewUrl = productUrl + separator + 'view=quick-view';
              quickViewBtn.setAttribute('data-url', quickViewUrl);
              
              quickViewBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                openQuickView(quickViewUrl);
              });
              
              imgContainer.appendChild(quickViewBtn);
            }

            const titles = product.querySelectorAll('h3, h4, [class*="title"], [class*="name"]');
            titles.forEach(title => {
              title.classList.add('RS-nosto-title');
            });

            const prices = product.querySelectorAll('[class*="price"]');
            prices.forEach(price => {
              price.classList.add('RS-nosto-price');
            });
          });
          
          initKeenSlider(container);
        } else {
          setTimeout(checkContent, 200);
        }
      };
      
      checkContent();
    });

    return newContainersFound;
  }

  function checkAndApply() {
    attempts++;

    if (applyNostoStyles()) {
      return;
    }

    if (attempts < config.maxAttempts) {
      setTimeout(checkAndApply, config.checkInterval);
    }
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkAndApply);
    } else {
      checkAndApply();
    }

    window.addEventListener('load', () => {
      setTimeout(checkAndApply, 1000);
    });

    if (typeof MutationObserver !== 'undefined') {
      let debounceTimer;
      
      const observer = new MutationObserver((mutations) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          const hasNewNodes = mutations.some(mutation => mutation.addedNodes.length > 0);
          if (hasNewNodes) {
            applyNostoStyles();
          }
        }, 250);
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  init();
})();
